module.exports = __webpack_public_path__ + "static/media/devices-icons.0b0ad7d9.svg";